import { render, staticRenderFns } from "./FieldSelector.vue?vue&type=template&id=39fc995e&scoped=true&"
import script from "./FieldSelector.vue?vue&type=script&lang=ts&"
export * from "./FieldSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FieldSelector.vue?vue&type=style&index=0&id=39fc995e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc995e",
  null
  
)

export default component.exports